import { TOrderStatusEnum } from 'api/orders/orders.types';
import type { TLocalize } from 'store/contexts/LocalizationContext/LocalizationContext.types';

const ORDER_STATUS_LABEL_KEYS: Record<TOrderStatusEnum, string> = {
  [TOrderStatusEnum.Created]: 'admin.orders.status.created',
  [TOrderStatusEnum.Payed]: 'admin.orders.status.payed',
  [TOrderStatusEnum.InProgress]: 'admin.orders.status.inprogress',
  [TOrderStatusEnum.InDelivery]: 'admin.orders.status.indelivery',
  [TOrderStatusEnum.Done]: 'admin.orders.status.done',
  [TOrderStatusEnum.Refunded]: 'admin.orders.status.refunded',
};

export const getOrderStatusSelectOptions = (localize: TLocalize) =>
  Object.values(TOrderStatusEnum).map((status) => ({
    id: status,
    label: localize(ORDER_STATUS_LABEL_KEYS[status]) as string,
  }));
